// import React, { useState, useContext } from "react";
// import { FaSearch } from "react-icons/fa";
// import { useNavigate, useLocation } from "react-router-dom";
// import { LoginContext } from "../../../contexts/loginContext";
// import { CapitalizeName } from "../../../utils/capitalizeName";
// import "./index.css";
// import { useSelector, useDispatch } from "react-redux";
// import { logout } from "../../../Redux/slices/authSlice";
// import {
//   AppBar,
//   Box,
//   Button,
//   IconButton,
//   Toolbar,
//   Typography,
//   Menu,
//   MenuItem,
// } from "@mui/material";
// import LogoutIcon from "@mui/icons-material/Logout";

// const Header = () => {
//   const { isAuthenticated, user } = useSelector((state) => state.auth);
//   const dispatch = useDispatch();
//   const [input, setInput] = useState("");
//   const navigate = useNavigate();
//   const location = useLocation();
//   const userName = CapitalizeName(user?.name || "");
//   console.log("Header state:", { isAuthenticated, user });

//   // For Resources dropdown
//   const [resourcesAnchorEl, setResourcesAnchorEl] = useState(null);
//   const isResourcesOpen = Boolean(resourcesAnchorEl);

//   const handleResourcesClick = (event) => {
//     setResourcesAnchorEl(event.currentTarget);
//   };

//   const handleResourcesClose = () => {
//     setResourcesAnchorEl(null);
//   };

//   const handleLogOut = () => {
//     localStorage.clear();
//     sessionStorage.clear();
//     dispatch(logout());
//     setTimeout(() => navigate("/"), 0);
//   };

//   const handleLogin = () => {
//     navigate("/login");
//   };

//   const isInterviewPage =
//     location.pathname === "/interview/question" ||
//     location.pathname === "/interview/finish";

//   return (
//     <AppBar
//       position="static"
//       className="header"
//       sx={{ background: "linear-gradient(135deg, #004d4d, #002626)" }}
//     >
//       <Toolbar>
//         {/* Logo Section */}
//         <Box
//           sx={{
//             flexGrow: 1,
//             display: "flex",
//             alignItems: "center",
//           }}
//         >
//           <img
//             src="/assests/images/logoAi.png"
//             alt="Logo"
//             className="logo"
//             onClick={() => navigate("/")}
//             style={{ width: "100px", height: "80px" }}
//           />
//         </Box>
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "center",
//             gap: 4,
//             alignItems: "center",
//             color: "white",
//           }}
//         >
//           <Box
//             sx={{
//               position: "relative",
//               cursor: "pointer",
//             }}
//             onMouseEnter={handleResourcesClick}
//             onMouseLeave={handleResourcesClose}
//           >
//             <Typography
//               variant="h6"
//               color="#9ACBD0"
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 1,
//               }}
//             >
//               Resources
//               <svg
//                 width="12"
//                 height="12"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="#006A71"
//                 strokeWidth="2"
//               >
//                 <path d="M6 9l6 6 6-6" />
//               </svg>
//             </Typography>

//             <Menu
//               anchorEl={resourcesAnchorEl}
//               open={isResourcesOpen}
//               onClose={handleResourcesClose}
//               MenuListProps={{
//                 "aria-labelledby": "resources-button",
//                 // Remove onMouseEnter from here
//                 onMouseLeave: handleResourcesClose,
//               }}
//               sx={{
//                 "& .MuiPaper-root": {
//                   backgroundColor: "#006A71", // Keep background
//                   color: "white", // Change text color to white for visibility
//                 },
//                 "& .MuiMenuItem-root": {
//                   "&:hover": {
//                     backgroundColor: "#033538", // Add hover effect for better UX
//                   },
//                 },
//               }}
//               PaperProps={{
//                 elevation: 1,
//                 sx: {
//                   mt: 1,
//                 },
//               }}
//             >
//               <MenuItem
//                 onClick={() => {
//                   handleResourcesClose();
//                   navigate("/about");
//                 }}
//                 sx={{ color: "white" }}
//               >
//                 About
//               </MenuItem>
//               <MenuItem
//                 onClick={() => {
//                   handleResourcesClose();
//                   navigate("/support");
//                 }}
//                 sx={{ color: "white" }}
//               >
//                 Support
//               </MenuItem>
//               <MenuItem
//                 onClick={() => {
//                   handleResourcesClose();
//                   navigate("/contact");
//                 }}
//                 sx={{ color: "white" }}
//               >
//                 Contact
//               </MenuItem>
//             </Menu>
//           </Box>
//           <Typography variant="3" color="#9ACBD0">
//             Pricing
//           </Typography>

//           {/* Only show Login and Get Started when NOT logged in */}
//           {!isAuthenticated && (
//             <>
//               <Button sx={{ color: "#9ACBD0" }} onClick={handleLogin}>
//                 Login
//               </Button>
//               <Button
//                 sx={{
//                   backgroundColor: "white",
//                   color: "#002626",
//                   padding: 1,
//                   "&:hover": {
//                     backgroundColor: "#033538",
//                     color: "white",
//                   },
//                   borderRadius: 2,
//                 }}
//               >
//                 Get Started
//               </Button>
//               <Button
//                 sx={{
//                   backgroundColor: "white",
//                   color: "#002626",
//                   padding: 1,
//                   "&:hover": {
//                     backgroundColor: "#033538",
//                     color: "white",
//                   },
//                   borderRadius: 2,
//                 }}

//                 onClick={()=>navigate("/interviewerjoining")}
//               >
//                 Join as interviewer
//               </Button>
//             </>
//           )}
//         </Box>

//         {/* Welcome Message */}
//         {isAuthenticated && (
//           <Typography
//             variant="h6"
//             className="welcome-text"
//             alignContent="center"
//             sx={{ ml: 3, color: "#006A71" }}
//           >
//             Welcome, {userName}
//           </Typography>
//         )}

//         {/* Logout Button */}
//         {!isInterviewPage && isAuthenticated && (
//           <IconButton
//             onClick={handleLogOut}
//             className="logout-btn"
//             sx={{ color: "black" }}
//           >
//             <LogoutIcon sx={{ fill: "#033538", fontSize: 28 }} />
//           </IconButton>
//         )}
//       </Toolbar>
//     </AppBar>
//     // <div className="row  header text-white border-bottom">
//     //   {/* <div className="col col-lg-1 d-flex justify-content-center align-items-center custom-border-end">
//     //     <img src="/assests/images/bullet-list.svg" alt="Bootstrap" />
//     //   </div> */}
//     //   <div className="col col-lg-4  d-flex align-items-center">
//     //     <img src="/assests/images/logopic.svg" alt="Bootstrap" />
//     //   </div>
//     //   {/* <div className="col col-lg-1 custom-border-end"></div> */}
//     //   <div className="col col-lg-5 d-flex gap-3 justify-content-evenly align-items-center ">
//     //   {isLoggedIn ? (<div className="welcome-class">Welcome,{userName}</div>):""}
//     //   </div>
//     // <div className="col col-lg-1 d-flex align-items-center justify-content-center">
//     // {!isInterviewPage && isLoggedIn &&
//     //   (<img src='/assests/images/material-symbols_logout.svg' alt={'Logout'} onClick={()=>handleLogOut()}></img>)}
//     // </div>

//     // </div>
//   );
// };

// export default Header;
























// import React, { useState } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// import { logout } from "../../../Redux/slices/authSlice";
// import { CapitalizeName } from "../../../utils/capitalizeName";

// import {
//   Menu,
//   MenuItem,
//   IconButton,
//   Button,
//   Typography,
// } from "@mui/material";
// import LogoutIcon from "@mui/icons-material/Logout";

// import "../assets/css/main.css";

// const Header = () => {
//   const { isAuthenticated, user } = useSelector((state) => state.auth);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const userName = CapitalizeName(user?.name || "");

//   const [resourcesAnchorEl, setResourcesAnchorEl] = useState(null);
//   const isResourcesOpen = Boolean(resourcesAnchorEl);

//   const handleResourcesClick = (e) => setResourcesAnchorEl(e.currentTarget);
//   const handleResourcesClose = () => setResourcesAnchorEl(null);

//   const handleLogOut = () => {
//     localStorage.clear();
//     sessionStorage.clear();
//     dispatch(logout());
//     navigate("/");
//   };

//   const isInterviewPage =
//     location.pathname === "/interview/question" ||
//     location.pathname === "/interview/finish";

//   return (
//     <header id="header" className="header fixed-top">
//       {/* <div className="container d-flex align-items-center justify-content-between"> */}

//         {/* LOGO */}
//         <a
//           href="/"
//           // className="logo d-flex align-items-center"
//           onClick={(e) => {
//             e.preventDefault();
//             navigate("/");
//           }}
//         >
//           <img
//             src="/assests/images/logoAi.png"
//             alt="Logo"
//             style={{ height: "50px", width: "50px" }}
//           />
//           <h1 sx={{ height: "50px", 
//                      width: "150px",
//                     fontweight: "bold",
//                     marginLeft: "10px",
//                   colour:"black"}}
//           >STRATEGIC HIRE</h1>
//         </a>

//         {/* NAV MENU */}
//         <nav id="navmenu" className="navmenu">
//           <ul>
//             <li>
//               <a href="#hero" className="active">Home</a>
//             </li>

//             {/* RESOURCES DROPDOWN */}
//             {/* <li
//               onMouseEnter={handleResourcesClick}
//               onMouseLeave={handleResourcesClose}
//               style={{ cursor: "pointer" }}
//             >
//               <span className="nav-link">
//                 Resources <i className="bi bi-chevron-down ms-1"></i>
//               </span>

//               <Menu
//                 anchorEl={resourcesAnchorEl}
//                 open={isResourcesOpen}
//                 onClose={handleResourcesClose}
//                 PaperProps={{
//                   sx: {
//                     backgroundColor: "#1b1a1a",
//                     color: "white",
//                     mt: 1,
//                   },
//                 }}
//               >
//                 <MenuItem onClick={() => navigate("/about")}>About</MenuItem>
//                 <MenuItem onClick={() => navigate("/support")}>Support</MenuItem>
//                 <MenuItem onClick={() => navigate("/contact")}>Contact</MenuItem>
//               </Menu>
//             </li> */}
//             <li>
//               <a href="/about">About</a>
//             </li><li>
//               <a href="/support">Support</a>
//             </li><li>
//               <a href="/contact">Contact</a>
//             </li>

//             <li>
//               <a href="#pricing">Pricing</a>
//             </li>

//             {/* AUTH BUTTONS */}
//             {!isAuthenticated && (
//               <>
//                 {/* <li>
//                   <Button
//                     variant="text"
//                     sx={{ color: "#e59d02" }}
//                     onClick={() => navigate("/login")}
//                   >
//                     Login
//                   </Button>
//                 </li> */}
//                 <li>
//                   <a className="btn-getstarted" href="/login">
//                     Login
//                   </a>
//                 </li>
//                 <li>
//                   <Button
//                     variant="outlined"
//                     sx={{ color: "#e59d02", borderColor: "#e59d02" }}
//                     onClick={() => navigate("/interviewerjoining")}
//                   >
//                     Join as interviewer
//                   </Button>
//                 </li>
//               </>
//             )}
//           </ul>

//           <i className="mobile-nav-toggle d-xl-none bi bi-list"></i>
//         </nav>

//         {/* AUTH USER */}
//         {isAuthenticated && (
//           <div className="d-flex align-items-center gap-3">
//             <Typography sx={{ color: "#e59d02" }}>
//               Welcome, {userName}
//             </Typography>

//             {!isInterviewPage && (
//               <IconButton onClick={handleLogOut}>
//                 <LogoutIcon sx={{ color: "#e59d02" }} />
//               </IconButton>
//             )}
//           </div>
//         )}
//       {/* </div> */}
//     </header>
//   );
// };

// export default Header;




























import React, { useState, useEffect  } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../../Redux/slices/authSlice";
import { CapitalizeName } from "../../../utils/capitalizeName";
import { IconButton, Typography } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
// import logo from "../assets/images/logo.jpeg"
import logo from "../assets/images/logoAi.png"
import "../assets/css/main.css"

const Header = () => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const userName = CapitalizeName(user?.name || "");

  const isInterviewPage =
    location.pathname === "/interview/question" ||
    location.pathname === "/interview/finish";


  useEffect(() => {
  const handleScroll = () => {
    if (window.scrollY > 50) {
      document.body.classList.add("scrolled");
    } else {
      document.body.classList.remove("scrolled");
    }
  };

  window.addEventListener("scroll", handleScroll);
  handleScroll(); // run once on page load

  return () => window.removeEventListener("scroll", handleScroll);
}, []);

  const handleLogOut = () => {
    localStorage.clear();
    sessionStorage.clear();
    dispatch(logout());
    navigate("/");
  };

  return (
    <header id="header" className="header fixed-top">

        {/* LOGO */}
        <a className="logo_and_title"
          href="/"
          // className="logo d-flex align-items-center"
          onClick={(e) => {
            e.preventDefault();
            navigate("/");
          }}
        >
          {/* <img src="/assests/images/logoAi.png" alt="Logo" /> */}
          <img src={logo} alt="Logo" />
          {/* <h1 className="logo_name">STRATEGIC HIRE</h1> */}
        </a>

        {/* NAV */}
        <nav id="navmenu" className="navmenu">
          <ul>
            <li><a href="/" className="active">Home</a></li>
            <li><a href="/about">About</a></li>
            {/* <li><a href="/support">Support</a></li> */}
            {/* <li><a href="/contact">Contact</a></li> */}
            <li><a href="#pricing">Pricing</a></li>
               </ul>

          <i className="mobile-nav-toggle d-xl-none bi bi-list"></i>
        </nav>

            {!isAuthenticated && (
              <div className="header-actions">
                <li>
                  <a className="btn-getstarted" href="/login">
                    Login
                  </a>
                </li>
                <li>
                  <a
                    className="btn-getstarted"
                    href="/interviewerjoining"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/interviewerjoining");
                    }}
                  >
                  Join as interviewer
                  </a>
                </li>
              </div>
            )}
       

        {/* AUTH USER */}
        {isAuthenticated && (
          <div className="auth-user">
            <Typography >
              Welcome, {userName}
            </Typography>

            {!isInterviewPage && (
              <IconButton className="logout-btn" onClick={handleLogOut}>
                <LogoutIcon className="logout-icon"  />
              </IconButton>
            )}
          </div>
        )}
    </header>
  );
};

export default Header;
